import { useEffect, useState } from "react";
import { getEnabledLanguages } from "../services/languageService";

/**
 * Loads the admin-managed, enabled language list once and shares it
 * across every mount (TopBar, mobile drawer, admin preview, etc).
 * Cheap table read — same pattern as getSiteSettings() being called
 * independently from both TopBar.js and Navbar.js.
 */
export default function useLanguages() {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      const data = await getEnabledLanguages();
      if (isMounted) {
        setLanguages(data);
        setLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  return { languages, loading };
}
